import VehicleInformation from './VehicleInformation';
import TransactionInformation from './TransactionInformation';
import { useSelector } from 'react-redux';
import { selectDocsFormData } from '../../redux-state/selectors';
import { STATE_MAPPER } from '../docs/constants';

function DocsOutputLeftSide() {
  const docsFormData = useSelector(selectDocsFormData)

  const getStateFullName = (abbr) => {
    return STATE_MAPPER[abbr] || abbr;
  };

  const formatDate = (dateString) => {
    // Split the string by the hyphen
    const [year, month, day] = dateString.split('-');

    // Return them in the desired order with slashes
    return `${month}/${day}/${year}`;
  }

  return (
    <div className='flex flex-col gap-4 w-[100%]'>
      <div className='flex flex-row text-gray-700 font-bold mb-2 items-center h-11'>
        Your Information
      </div>

      <div className='bg-white p-6 rounded-xl text-sm border border-gray-300'>
        <div className='text-gray-700 mb-3 font-bold'>
          Location Information
        </div>

        <div className='flex flex-col lg:flex-row w-full gap-6 lg:gap-24 mb-6'>
          <div className='flex flex-col w-[100%] text-gray-700 gap-2'>
            <div className='flex flex-row justify-between'>
              <div>
                Zip Code:
              </div>
              <div className='font-medium'>
                {docsFormData?.zipCode}
              </div>
            </div>

            <div className='flex flex-row justify-between'>
              <div>
                City:
              </div>
              <div className='font-medium'>
                {docsFormData?.city}
              </div>
            </div>

            <div className='flex flex-row justify-between'>
              <div>
                Outside city limits:
              </div>
              <div className='font-medium'>
                {docsFormData?.outSideCityLimit ? "Yes": "No"}
              </div>
            </div>
          </div>

          <div className='flex flex-col w-[100%] text-gray-700 gap-2'>
            <div className='flex flex-row justify-between'>
              <div>
                State:
              </div>
              <div className='font-medium'>
                {getStateFullName(docsFormData?.state)}
              </div>
            </div>

            <div className='flex flex-row justify-between'>
              <div>
                County:
              </div>
              <div className='font-medium'>
                {docsFormData?.country}
              </div>
            </div>
          </div>
        </div>

        <VehicleInformation/>
        <TransactionInformation/>

        {(docsFormData?.insuranceCompany || docsFormData?.insuranceExpirationDate || docsFormData?.insuranceDate || docsFormData?.insurancePolicyNumber) &&
          <div>
            <div className='border-t-2 border-t-gray-100 mb-3'>
              <div className='text-gray-700 mt-6 font-medium'>
                Insurance Information
              </div>
            </div>

            <div className='flex flex-col lg:flex-row w-full gap-6 lg:gap-24 mb-6'>
              <div className='flex flex-col w-[100%] text-gray-700 gap-2'>
                <div className='flex flex-row justify-between'>
                  <div>
                    Insurance Company:
                  </div>
                  <div className='font-medium'>
                    {docsFormData?.insuranceCompany}
                  </div>
                </div>

                <div className='flex flex-row justify-between'>
                  <div>
                    Insurance Expiration Date:
                  </div>
                  <div className='font-medium'>
                    {formatDate(docsFormData?.insuranceExpirationDate)}
                  </div>
                </div>
              </div>

              <div className='flex flex-col w-[100%] text-gray-700 gap-2'>
                <div className='flex flex-row justify-between'>
                  <div>
                    Insurance Date:
                  </div>
                  <div className='font-medium'>
                    {formatDate(docsFormData?.insuranceDate)}
                  </div>
                </div>

                <div className='flex flex-row justify-between'>
                  <div>
                    Insurance Number:
                  </div>
                  <div className='font-medium'>
                    {docsFormData?.insurancePolicyNumber}
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  )
}

export default DocsOutputLeftSide;
